import type { ImportedInvoiceReviewLineValues } from '../types/importedInvoiceReviewFormSchema'
import { isImportedInvoiceReviewLineEmpty } from './isImportedInvoiceReviewLineEmpty'

/** The form index of every line approve sends, in order: fully empty lines are not sent. */
export const getFilledImportedInvoiceReviewLineIndexes = (lines: ImportedInvoiceReviewLineValues[]): number[] =>
  lines.flatMap((line, lineIndex) => (isImportedInvoiceReviewLineEmpty(line) ? [] : [lineIndex]))
